// Arabic strings for the B2B (BusinessWorkspace) analytics report
// (components/Reports/BusinessWorkspace).
const trans = {
  // Page chrome
  B2B: "بيع الشركات",
  "Sales, receivables, wallets and fulfilment for your business (wholesale) customers.":
    "المبيعات والمستحقات والمحافظ والتجهيز لعملائك من الشركات (الجملة).",

  // Tabs / sections
  Pulse: "النبض",
  Orders: "الطلبات",
  "Line Items": "عناصر الطلب",
  Businesses: "الشركات",
  "Wallet Top-ups": "شحن المحفظة",

  // KPIs
  "B2B revenue": "إيرادات الأعمال",
  "B2B orders": "طلبات الأعمال",
  "Active businesses": "الشركات النشطة",
  "Avg business spend": "متوسط إنفاق الشركة",
  "Avg order value": "متوسط قيمة الطلب",
  Discounts: "الخصومات",
  "Wallet top-ups": "شحن المحفظة",
  "Outstanding (AR)": "المستحقات (الذمم المدينة)",
  "Order value from businesses (excludes cancelled/refunded orders & wallet top-ups)":
    "قيمة الطلبات من الشركات (باستثناء الطلبات الملغاة/المستردة وشحن المحفظة)",
  "Number of business orders placed in this period": "عدد طلبات الشركات في هذه الفترة",
  "Distinct businesses that ordered in this period": "عدد الشركات المختلفة التي طلبت في هذه الفترة",
  "B2B revenue ÷ active businesses": "إيرادات الأعمال ÷ الشركات النشطة",
  "Average value of a single B2B order (revenue ÷ orders)":
    "متوسط قيمة طلب واحد من الأعمال (الإيرادات ÷ الطلبات)",
  "Total discounts applied to B2B orders in this period": "إجمالي الخصومات على طلبات الأعمال في هذه الفترة",
  "Prepaid wallet credit added by businesses in this period":
    "رصيد المحفظة المدفوع مسبقًا الذي أضافته الشركات في هذه الفترة",
  "Total unpaid business orders (receivable) as of now": "إجمالي طلبات الشركات غير المدفوعة (المستحقة) حتى الآن",

  // Wastage
  "Wastage invoices": "فواتير الهدر",

  // AR aging module
  "Receivables — AR aging": "المستحقات — أعمار الذمم المدينة",
  "AR (accounts receivable) is money businesses owe you on unpaid orders, shown as of today (independent of the date filter). Bucketed by how long each order has been outstanding — 90+ days is overdue.":
    "الذمم المدينة هي الأموال المستحقة لك على الشركات مقابل الطلبات غير المدفوعة، معروضة حتى تاريخ اليوم (بصرف النظر عن فلتر التاريخ). مصنّفة حسب مدة بقاء كل طلب مستحقًا — أكثر من 90 يومًا يُعد متأخرًا.",
  "Top outstanding": "أعلى المستحقات",
  "0–30 days": "0–30 يومًا",
  "31–60 days": "31–60 يومًا",
  "61–90 days": "61–90 يومًا",
  "90+ days": "أكثر من 90 يومًا",

  // Wallet module
  "Wallet intelligence": "تحليلات المحفظة",
  "Prepaid wallet credit. Balance held is the credit businesses hold right now (as of today); top-ups are credit added during the selected period. 'Out of credit' counts businesses with a zero or negative balance.":
    "رصيد المحفظة المدفوع مسبقًا. الرصيد المحتفظ به هو الرصيد الذي تملكه الشركات حاليًا (حتى اليوم)؛ وعمليات الشحن هي الرصيد المُضاف خلال الفترة المحددة. \"بدون رصيد\" تحتسب الشركات ذات الرصيد الصفري أو السالب.",
  "Balance held": "الرصيد المحتفظ به",
  "Top-ups (period)": "عمليات الشحن (الفترة)",
  "Funded businesses": "الشركات الممولة",
  "Businesses that currently hold a positive wallet balance.": "الشركات التي تملك حاليًا رصيد محفظة موجبًا.",
  "Out of credit": "بدون رصيد",
  "Businesses with a zero or negative wallet balance — they must top up before placing more prepaid orders.":
    "الشركات ذات رصيد المحفظة الصفري أو السالب — يجب عليها الشحن قبل تقديم مزيد من الطلبات المدفوعة مسبقًا.",
  "Top balances": "أعلى الأرصدة",

  // Leaderboard + rank lists
  "Top businesses by revenue": "أعلى الشركات حسب الإيرادات",
  "Businesses ranked by revenue in the selected period. Each business is matched through the branch on its orders, so this can read lower than total B2B revenue when an order has no branch link.":
    "الشركات مرتبة حسب الإيرادات في الفترة المحددة. تُطابَق كل شركة عبر الفرع المرتبط بطلباتها، لذا قد تظهر القيمة أقل من إجمالي إيرادات الأعمال عندما لا يكون للطلب فرع مرتبط.",
  Last: "آخر",
  "Payment mix": "توزيع المدفوعات",
  "B2B revenue split by payment method in the selected period. The number after the amount is the order count.":
    "توزيع إيرادات الأعمال حسب طريقة الدفع في الفترة المحددة. الرقم بعد المبلغ هو عدد الطلبات.",
  "Top products": "أفضل المنتجات",
  "Best-selling products to businesses by revenue in the selected period. The number after the amount is units sold; '—' means the product was since deleted.":
    "أكثر المنتجات مبيعًا للشركات حسب الإيرادات في الفترة المحددة. الرقم بعد المبلغ هو عدد الوحدات المباعة؛ \"—\" يعني أن المنتج حُذف لاحقًا.",

  // Trend
  "Revenue trend": "اتجاه الإيرادات",
  "B2B revenue per day over the selected period": "إيرادات الأعمال يوميًا خلال الفترة المحددة",

  // Filters
  "All businesses": "جميع الشركات",
  "All payments": "جميع المدفوعات",
  Paid: "مدفوع",
  Unpaid: "غير مدفوع",

  // Table titles (sections)
  "B2B orders": "طلبات الأعمال",
  "B2B line items": "عناصر طلبات الأعمال",

  // Table columns
  Order: "الطلب",
  Business: "الشركة",
  Branch: "الفرع",
  Contact: "جهة الاتصال",
  Date: "التاريخ",
  Payment: "الدفع",
  Gross: "الإجمالي",
  Discount: "الخصم",
  Net: "الصافي",
  "Order status": "حالة الطلب",
  "Payment status": "حالة الدفع",
  Product: "المنتج",
  Qty: "الكمية",
  "Unit price": "سعر الوحدة",
  Total: "الإجمالي",
  Branches: "الفروع",
  Phone: "الهاتف",
  Spend: "الإنفاق",
  Balance: "الرصيد",
  Outstanding: "المستحق",
  Terms: "شروط الدفع",
  "Last order": "آخر طلب",
  "Top-up": "الشحن",
  "Wallet balance": "رصيد المحفظة",
  days: "يوم",
  Prepaid: "مدفوع مسبقًا",

  // Table chrome
  "Showing the first": "عرض أول",
  "rows of": "صفًا من",
  "Narrow the date range to see the rest.": "ضيّق نطاق التاريخ لعرض الباقي.",
};

export default trans;
